import React, { useState, useEffect } from 'react';
import './DeleteAccount.css';

const DeleteAccount = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [email, setEmail] = useState('');
  const [showDialog, setShowDialog] = useState(false);
  const [isValid, setIsValid] = useState(false);

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleEmailChange = (e) => {
    const inputEmail = e.target.value;
    setEmail(inputEmail);
    setIsValid(validateEmail(inputEmail));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isValid) {
      setShowDialog(true);
      // In a real application, you would send the request to your backend here
    }
  };

  const closeDialog = () => {
    setShowDialog(false);
    setEmail('');
  };

  return (
    <div className="delete-account-container">
      <div className="delete-account-content">
        <h1>Delete Your Account</h1>
        
        <div className="delete-account-info">
          <p>We're sorry to see you go. Before you delete your account, please be aware of the following:</p>
          <ul>
            <li>All of your data and personal information will be permanently deleted.</li>
            <li>This action cannot be undone once processed.</li>
            <li>Any active subscriptions will be canceled.</li>
          </ul>
        </div>

        {!showDialog ? (
          <form onSubmit={handleSubmit} className="delete-account-form">
            <div className="form-group">
              <label htmlFor="email">Please enter your email address to confirm:</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={handleEmailChange}
                placeholder="your-email@example.com"
                required
              />
            </div>
            <button 
              type="submit" 
              className={`delete-button ${isValid ? 'valid' : ''}`}
              disabled={!isValid}
            >
              Request Account Deletion
            </button>
          </form>
        ) : (
          <div className="confirmation-dialog">
            <div className="dialog-content">
              <div className="dialog-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h2>Request Received</h2>
              <p>We've received your request to delete the account associated with <strong>{email}</strong>.</p>
              <p>We'll process your request within 24 hours and send you a confirmation email when completed.</p>
              <button onClick={closeDialog} className="close-button">Close</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DeleteAccount;